// Presentation only: keep exact identifiers in proposals and validation data.
export function reviewLanguage(answer,groups=[],ads=[]) {
 let text=String(answer||'').replace(/Timing\s*&\s*adjustments/gi,'Campaign settings').replace(/Save changes/g,'Save draft');
 const names=[...groups.map(g=>[g.id,g.name]),...ads.map(a=>[a.resource,a.name||a.content?.name||'Existing ad'])].filter(([id,name])=>id&&name).sort((a,b)=>b[0].length-a[0].length);
 for(const [id,name] of names){const escaped=id.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');text=text.replace(new RegExp(`(?<![A-Za-z0-9_])${escaped}(?![A-Za-z0-9_])`,'g'),()=>name);}
 return text;
}

export function rateClaims(content) {
 const copy=[...(content?.headlines||[]),...(content?.descriptions||[])].map(x=>x.text||'').join(' · ');
 return [...new Set([...copy.matchAll(/(\d+(?:\.\d+)?\s*%)[\s*]*(?:p\.?\s*a\.?|(?:NRE|NRI|FD|fixed deposit|tax-free|assured|annual|savings| )*\s*interest)/gi)].map(m=>m[1]))];
}
